<template>
  <div class="edit-block">
    <div class="edit-block-form">
      <Form ref="libForm" :model="libForm" :rules="ruleValid" :label-width="175">
        <div class="edit-block_title">基本信息</div>
        <div class="edit-block-side" v-for="(itemArray, index) in errInfo" :key="index">
          <FormItem
            v-for="(Item, index) in itemArray"
            :key="index"
            :label="Item.label"
            :prop="Item.field">
            <template v-if="Item.type === 'input'">
              <Input v-model.trim="libForm[Item.field]" :placeholder="`请输入${Item.label}`" />
            </template>
            <template v-else-if="Item.type === 'date'">
              <DatePicker v-model="Item.value" format="yyyy-MM-dd" type="date" placeholder="请选择日期" :clearable="false" :clearError="false" :editable="false"></DatePicker>
            </template>
            <template v-else-if="Item.type === 'daterange'">
              <DatePicker v-model="Item.value" format="yyyy-MM-dd" type="daterange" placeholder="请选择日期" :clearable="false" :clearError="false" :editable="false"></DatePicker>
            </template>
            <template v-else-if="Item.type === 'textarea'">
              <Input v-model.trim="Item.value" :placeholder="`请输入${Item.label}`" type="textarea"/>
            </template>
            <template v-else-if="Item.type === 'radio'">
              <RadioGroup v-model="Item.value">
                <Radio v-for="(item, index) in dataStandOpts[Item.field]" :key="index" :label="item.label">
                  {{item.text}}
                </Radio>
              </RadioGroup>
            </template>
            <template v-else-if="Item.type === 'select'">
              <Select :ref="'sel' + Item.field" v-model="Item.value" placeholder="请选择" @on-change="handleSelectChange(Item)" @on-open-change="selOpenEvt(Item.field)">
                <Option v-for="(item, index) in dataStandOpts[Item.field]" :value="item.value" :key="index" :title="item.text || item.value">{{item.text || item.value}}</Option>
              </Select>
            </template>
          </FormItem>
          <FormItem v-if="isShowFooter">
            <div class="return-bottom">
              <div class="return-bottom-content">
                <div class="button-group">
                  <Button @click.stop="goBack">暂不处理</Button>
                  <Button type="primary" @click.stop="submit('libForm')" :disabled="btnDisabled">确认完成</Button>
                </div>
              </div>
            </div>
          </FormItem>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import errFixedMixin from './errFixedMixin'
export default {
  mixins: [errFixedMixin],
  props: {
    id: [String, Number],
    libForm: Object,
    type: String,
    isShowFooter: Boolean,
    btnDisabled: Boolean
  },
  data() {
    return {
      ruleValid: {
        name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        prod_name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        prd_name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        yibao_drug: [{ required: true, message: '不能为空', trigger: 'blur' }],
        breed_name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        doctor_name: [{ required: true, message: '不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    handleSelectChange(item) {
      if (this.$route.params.type === 'jiyaoData' && item.field === 'one_directory') {
        this.showDefaultOptions(item.value, true)
      }
    },
    selOpenEvt(field) {
      if (this.$refs['sel' + field] && this.$refs['sel' + field][0].$el.querySelector('.ivu-select-dropdown').scrollTop === 0) {
        this.$nextTick(() => {
          this.$refs['sel' + field][0].$el.querySelector('.ivu-select-dropdown').scrollTop = 0
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .edit-block {
    position: relative;
    padding-top: 30px;
  }
  .submit-btn {
    position: absolute;
    top: 15px;
    right: 20px;
    z-index: 10000;
  }
  .edit-block-side {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    .ivu-input-wrapper,
    .ivu-select,
    .ivu-date-picker {
      width: 220px;
    }
    .ivu-form-item {
      .ivu-radio-wrapper {
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
  .edit-block_title {
    font-size: 14px;
    font-weight: bold;
    border: 0;
    margin-bottom: 30px;
  }
  .return-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    -webkit-box-shadow: 0 2px 6px rgba(135, 150, 176, 0.18);
    box-shadow: 0 2px 6px rgba(135, 150, 176, 0.18);
    z-index: 2;
    .return-bottom-content {
      width: 1000px;
      margin: 0 auto;
      overflow: hidden;
      .button-group {
        float: right;
        height: 60px;
        .ivu-btn {
          width: 80px;
          height: 28px;
          margin: 16px 10px;
        }
      }
    }
  }
  .edit-block__ope {
    display: inline-block;
    margin-left: 10px;
    .yjh-icon {
      margin-right: 0;
    }
    .yjh-icon + .yjh-icon {
      margin-left: 12px;
    }
  }
  .alias-name-wrapper {
    margin-bottom: 20px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  /deep/ .ivu-select-single {
    .ivu-select-selection {
      .ivu-select-placeholder,
      .ivu-select-selected-value {
        height: 30px;
        line-height: 30px;
      }
    }
  }
</style>
<style lang="scss">
  .ivu-form-item-error-tip {
    padding-left: 20px;
  }
  .ivu-select .ivu-select-dropdown {
    width: 220px;
  }
</style>
